"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSwaggerParametersFromJoiObject = exports.makeQueryParametersFromJoiObject = void 0;
var tslib_1 = require("tslib");
var joi_to_swagger_1 = tslib_1.__importDefault(require("joi-to-swagger"));
var makeQueryParametersFromJoiObject = function (options) {
    var _a;
    var swaggerSchema = (0, joi_to_swagger_1.default)(options.schema).swagger;
    return {
        requestBody: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (options.hasOwnProperty('description') && { description: options.description })), (options.hasOwnProperty('required') && { required: options.required })), { content: (_a = {},
                _a[options.contentType ? options.contentType : 'application/json'] = {
                    schema: swaggerSchema,
                },
                _a) }),
    };
};
exports.makeQueryParametersFromJoiObject = makeQueryParametersFromJoiObject;
var makeSwaggerParametersFromJoiObject = function (params) {
    var finalParameters = [];
    params.forEach(function (swaggerObject) {
        var swaggerSchema = (0, joi_to_swagger_1.default)(swaggerObject.schema).swagger;
        finalParameters.push.apply(finalParameters, Object.entries(swaggerSchema.properties).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            return tslib_1.__spreadArray(tslib_1.__spreadArray([], acc, true), [
                {
                    in: swaggerObject.paramsType,
                    name: key,
                    schema: value,
                },
            ], false);
        }, []));
    });
    return finalParameters;
};
exports.makeSwaggerParametersFromJoiObject = makeSwaggerParametersFromJoiObject;
//# sourceMappingURL=query.parameters.from.joi.object.js.map